import isFunction from 'lodash-es/isFunction';
import * as React from 'react';
import styled from 'styled-components';
import { HashHint } from '../components/HashHint';
import { Button } from './Button';
import { KEY } from './constants';
export const canShowHashHint = (value, selectionEnd = Infinity) => {
    const index = value.lastIndexOf('#');
    const visible = index !== -1;
    const filter = visible ? value.substring(index + 1, selectionEnd) : '';
    return { visible, filter };
};
const ReplyContainer = styled.div `
  // border: 1px solid #51b651;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 74px;
  padding: 2px;
`;
const TextArea = styled.textarea `
  border: none;
  flex: 1;
  padding: 2;
  outline: 'none';
  resize: 'none';
`;
const ButtonsContainer = styled.div `
  padding-top: 4px;
`;
export class Reply extends React.Component {
    constructor(props) {
        super(props);
        this.showHashHint = () => {
            const { textArea, textArea: { selectionEnd } } = this;
            let value = '';
            this.setState(({ value: prevValue }) => {
                value = prevValue.substring(0, selectionEnd) + '#' + prevValue.slice(selectionEnd);
                return Object.assign({ value }, canShowHashHint(value));
            }, () => {
                const { onValueChange } = this.props;
                if (isFunction(onValueChange)) {
                    onValueChange(value);
                }
                textArea.selectionEnd = selectionEnd + 1;
            });
        };
        this.handleChange = (event) => {
            const { textArea: { selectionEnd } } = this;
            const { target: { value } } = event;
            this.setState(Object.assign({ value }, canShowHashHint(value, selectionEnd)), () => {
                const { onValueChange } = this.props;
                if (isFunction(onValueChange)) {
                    onValueChange(value);
                }
            });
        };
        this.handleKeyDown = (event) => {
            const { onKeyDown } = this.props;
            const { visible } = this.state;
            if (!visible || !this.hashHint || this.hashHint.isEmpty) {
                if (this.hashHint && this.hashHint.isEmpty) {
                    this.setState({ visible: false });
                }
                if (isFunction(onKeyDown)) {
                    onKeyDown(event);
                }
                return;
            }
            const { keyCode } = event;
            if (!KEY[keyCode]) {
                return;
            }
            event.preventDefault();
            if (keyCode === KEY.Up) {
                this.hashHint.prev();
                return;
            }
            if (keyCode === KEY.Down) {
                this.hashHint.next();
                return;
            }
            if (keyCode === KEY.Left) {
                const canBack = this.hashHint.back();
                if (!canBack) {
                    this.setState({ visible: false });
                }
                return;
            }
            if (keyCode === KEY.Enter || keyCode === KEY.Right) {
                this.hashHint.select();
                return;
            }
            if (keyCode === KEY.Esc) {
                this.setState({ visible: false });
                return;
            }
            // if (keyCode === KEY.Ctrl) {
            //   this.setState({ visible: true });
            //   return;
            // }
        };
        this.setHashHint = (hashHint) => {
            this.hashHint = hashHint;
        };
        this.setTextArea = (textArea) => {
            this.textArea = textArea;
        };
        this.handleHashHintSelect = (item) => {
            const { textArea, textArea: { selectionEnd } } = this;
            const { value: prevValue } = this.state;
            const lastIndexOfH = prevValue.lastIndexOf('#');
            const value = prevValue.substring(0, lastIndexOfH) + item + prevValue.slice(selectionEnd);
            const diff = prevValue.substring(lastIndexOfH, selectionEnd);
            this.setState({ value, visible: false }, () => {
                const { onValueChange } = this.props;
                if (isFunction(onValueChange)) {
                    onValueChange(value);
                }
                textArea.selectionEnd = selectionEnd - (diff.length - 1) + (item.length - 1);
            });
        };
        const { value } = props;
        this.state = {
            filter: '',
            value,
            visible: false
        };
    }
    componentDidMount() {
        const { focus } = this.props;
        if (focus) {
            this.textArea.focus();
        }
    }
    componentWillReceiveProps(props) {
        const { textArea, textArea: { selectionEnd } } = this;
        const { disabled, focus, value } = props;
        let canFocus = false;
        this.setState(state => {
            const { value: prevValue } = state;
            if (value !== prevValue) {
                canFocus = true;
            }
            return Object.assign({ value }, canShowHashHint(value, selectionEnd));
        }, () => {
            if (!textArea) {
                return;
            }
            if (canFocus || (!disabled && focus)) {
                textArea.focus();
            }
        });
    }
    render() {
        const { handleChange, handleKeyDown, handleHashHintSelect, showHashHint, setHashHint, setTextArea } = this;
        const { disabled, placeholder, hashHintData, hashHintMaxWidth, hashHintMixWidth, hashHintShortcut } = this.props;
        const { filter, visible, value } = this.state;
        return (React.createElement(ReplyContainer, null,
            visible && (React.createElement(HashHint, { ref: setHashHint, data: hashHintData, filter: filter, maxWidth: hashHintMaxWidth, minWidth: hashHintMixWidth, onSelect: handleHashHintSelect })),
            React.createElement(TextArea, { ref: setTextArea, disabled: disabled, placeholder: placeholder, value: value, onChange: handleChange, onKeyDown: handleKeyDown }),
            hashHintShortcut && (React.createElement(ButtonsContainer, null,
                React.createElement(Button, { disabled: disabled, onClick: showHashHint }, "#")))));
    }
}
//# sourceMappingURL=Reply.js.map